import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import GamePage from "@/pages/GamePage";
import AdultPasswordResetPage from "@/components/AdultPasswordResetPage";
import AdultWorkspacePage from "@/components/AdultWorkspacePage";
import AdultAccountPage from "@/components/AdultAccountPage";

import StudentAccessPage, { StudentPlayPage } from '@/components/StudentAccessPage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<GamePage />} />
          <Route path="/student" element={<StudentAccessPage />} />
          <Route path="/student/play" element={<StudentPlayPage />} />
          <Route path="/account" element={<AdultAccountPage />} />
          <Route path="/adult-password-reset" element={<AdultPasswordResetPage />} />
          <Route path="/family" element={<AdultWorkspacePage workspace="family" />} />
          <Route path="/teacher" element={<AdultWorkspacePage workspace="teacher" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
